import Vue from 'vue';
import Vuex from 'vuex';
import { UserStore } from '@/store/modules/user.store';
import { SmartwatchStore } from '@/store/modules/smartwatch.store';
import { ClientStore } from '@/store/modules/client.store';
import { WalkStore } from '@/store/modules/walk.store';
import { LocationStore } from '@/store/modules/location.store';
import { NotificationStore } from "@/store/modules/notification.store";
import { EmployeeStore } from "@/store/modules/employee.store";
import { EnvironmentConfigurationStore } from "@/store/modules/environment.config.store";

Vue.use(Vuex);

export interface RootState {}

export default new Vuex.Store<RootState>({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    UserStore,
    SmartwatchStore,
    ClientStore,
    WalkStore,
    LocationStore,
    NotificationStore,
    EmployeeStore,
    EnvironmentConfigurationStore
  }
});
